export const apiEndpoint = { 
    pdfBaseUri:  window.location.host.includes("localhost") ? "https://pdf-uat.meon.co.in" : "https://pdf.meon.co.in",
    esignBaseUri: window.location.host.includes("localhost") ?  "http://127.0.0.1:8000" : "https://esign.meon.co.in",
    archiveDataBaseUri: process.env.REACT_APP_ARCHIVE_DATA_BASE_URI || "https://esignuat.meon.co.in",
    archiveActionBaseUri: process.env.REACT_APP_ARCHIVE_ACTION_BASE_URI || "https://esign-uat.meon.co.in",
}
